module.exports = __webpack_public_path__ + "img/Icons-10.60df3a8c.png";